module.exports = __webpack_public_path__ + "img/ratan-tata-sir.57911980.png";